export default "__VITE_ASSET__dcb5ea82__"